function formatPhoneNumber(value: string) {
  if (!value) return value;

  const phoneNumber = value.replace(/[^\d+]/g, "");

  const phoneNumberLength = phoneNumber.length;

  if (phoneNumberLength === 10 && !phoneNumber.includes("+")) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
      3,
      6,
    )}-${phoneNumber.slice(6, 10)}`;
  }
  if (phoneNumberLength === 12 && phoneNumber.includes("+")) {
    return `${phoneNumber.slice(0, 2)} ${phoneNumber.slice(
      2,
      5,
    )} ${phoneNumber.slice(5, 8)} ${phoneNumber.slice(8, 12)}`;
  }
  if (phoneNumberLength === 13 && phoneNumber.includes("+")) {
    return `${phoneNumber.slice(0, 3)} ${phoneNumber.slice(
      3,
      6,
    )} ${phoneNumber.slice(6, 13)}`;
  }
  if (phoneNumberLength === 14 && phoneNumber.includes("+")) {
    return `${phoneNumber.slice(0, 3)} ${phoneNumber.slice(
      3,
      6,
    )} ${phoneNumber.slice(6, 14)}`;
  }
  if (phoneNumberLength > 14 && phoneNumber.includes("+")) {
    return `${phoneNumber.slice(0, 3)} ${phoneNumber.slice(
      3,
      phoneNumberLength,
    )}`;
  }
  return phoneNumber;
}

export default formatPhoneNumber;
